import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceLineBreaks',
    standalone: false
})
export class ReplaceLineBreaksPipe implements PipeTransform {


    public transform(value: string, ...args: any[]): string {
        value = value.replace(/^\s*-\s*(?<contenido>[^\n]+)\n*/gm, '<li class="text-left">$<contenido></li>');
        value = value.replace(/(?<list_items><li[\s\S]*>[\s\S]+<\/li>)/gm, '<ul class="list-disc ml-4">$<list_items></ul>');
        // return value.replace(/\n/g, '<br/>');
        return value;
    }
}
